import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_MOBILE_APP_RELEASES_ANDROID = defineFcm('mobile_app_releases_android')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				upgrade_recommended: {
					type: 'array',
					shape: {
						type: 'object',
						shape: {
							version: { type: 'string' },
							build: { type: 'string', optional: true },
						},
					},
				},
				upgrade_required: {
					type: 'array',
					shape: {
						type: 'object',
						shape: {
							version: { type: 'string' },
							build: { type: 'string', optional: true },
						},
					},
				},
			},
		}),
	)
	.withDefault({
		upgrade_recommended: [],
		upgrade_required: [],
	})
	.toConfig({
		owner: 'squad-mobile',
		scope: 'corgi-middle-end',
		context: 'Mobile App (Android)',
		description: `Specifies which versions of the Android mobile app should prompt the user to upgrade, and which ones should force them to upgrade.  We use this to ensure users are on current and working versions of the app.  When the user's Android app is brought to the foreground it calls us to "register" its application and device information and we respond with a status that tells the app whether their current version is okay, should be upgraded, or must be upgraded.

On Android, "version" corresponds to the user-facing version name (for example "1.2.3") and "build" corresponds to the version code (for example "10203").

How matching works:

- "version" is matched as a literal string against the version the Android app reports (for example "1.2.3").  There are no wildcards and no semver-aware prefix matching.  To target a whole release line you must list every full major.minor.patch version in that line individually (for example "1.2.0", "1.2.1", "1.2.2", ...).
- "build" is optional.  Include both "version" and "build" to target one specific build of a version.  Omit "build" to match all builds for that exact version.
- Entries in "upgrade_required" take precedence over "upgrade_recommended": if the same reported version matches both lists, the user is required to upgrade.
- An empty config (the default) means every version of the Android app is considered up to date.`,
		import: false,
		template: {
			upgrade_recommended: [
				{
					version: '0.0.0',
					build: '0000',
				},
			],
			upgrade_required: [
				{
					version: '0.0.0',
					build: '0000',
				},
			],
		},
	});
